module.exports = __webpack_public_path__ + "static/media/thumbnail.3f3e068b.jpg";